import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import Grid from "@mui/material/Grid2";
import CallIcon from '@mui/icons-material/Call';
import { Link } from "react-router-dom"; // Added missing import

function FooterTerms() {
  return (
    <Box sx={{ backgroundColor: "#007BFF", color: "white", py: 3 }}>
      <Grid container spacing={4} justifyContent="center" mt='2%'>
        {/* Company Info */}
        <Grid item size={{ xs: 12, sm: 4 }} textAlign="left">
          <Typography variant="h6" fontWeight="bold">
            Company Info
          </Typography>
          <Link to="/about/privacy" style={{ textDecoration: 'none', color: 'white' }}>
            <Typography variant="body2">Privacy Policy</Typography>
          </Link>
          <Link to="/about/pricing" style={{ textDecoration: 'none', color: 'white' }}>
            <Typography variant="body2">Product and Pricing</Typography>
          </Link>
          <Link to="/about/terms" style={{ textDecoration: 'none', color: 'white' }}>
            <Typography variant="body2">Terms And conditions</Typography>
          </Link>
        </Grid>

        {/* Book Now */}
        <Grid item size={{ xs: 12, sm: 2 }} textAlign="left">
          <Typography variant="h6" fontWeight="bold">
            Book Now
          </Typography>
          <Typography variant="body2">Appointment</Typography>
        </Grid>

        {/* Contact */}
        <Grid item size={{ xs: 12, sm: 3 }} textAlign="left">
          <Typography variant="h6" fontWeight="bold">
            Contact
          </Typography>
          <Box display="flex" alignItems="center">
            <CallIcon sx={{ width: '20px', height: '20px' }} />
            <Typography variant="body1">9676272383</Typography>
          </Box>
          <Box display="flex" alignItems="center" mt={1}>
            <Typography variant="body1" sx={{ fontWeight: 'bold', mr: 1 }}>Email:</Typography>
            <Typography variant="body1"> <a href="mailto:support@clearbiz.ai" style={{ color: 'white', textDecoration: 'none' }}>support@clearbiz.ai</a></Typography>          </Box>
        </Grid>
      </Grid>

      {/* Divider */}
      <Divider sx={{ backgroundColor: "white", opacity: 0.5, mb: '5%', mt: 2, mx: "auto", width: "80%" }} />
    </Box>
  );
}

export default FooterTerms;
